import React, { useEffect } from 'react';

import { Methods } from '~/api/finance/financeApiTypes';
import { buyAbonnement } from '~/feature/book/buyAbonnement/buyAbonnement.data';
import { buyAbonnementSelector } from '~/feature/book/buyAbonnement/buyAbonnement.selector';
import { buyAbonnementActions } from '~/feature/book/buyAbonnement/buyAbonnement.slice';
import { ChoosePayModal } from '~/feature/finance/BuyingSteps/ChoosePay/ChoosePayModal';
import { ym } from '~/feature/yandex/YandexMetrikaInit';
import { AbonnementTypeEnum } from '~/graphql/books/factory/abonement/AbonnementFactoryTypes';
import { useAppDispatch, useAppSelector } from '~/store';

interface BuyAbonnementChoosePayModalProps {
  price: number;
  abonnementType: AbonnementTypeEnum;
  onBack?: () => void;
  bookId?: number | null;
}

export const BuyAbonnementChoosePayModal = ({
  price, abonnementType, onBack, bookId = null,
}: BuyAbonnementChoosePayModalProps) => {
  const dispatch = useAppDispatch();
  const { isOpenChoosePayModal } = useAppSelector(buyAbonnementSelector);

  useEffect(() => {
    if (isOpenChoosePayModal) {
      ym('reachGoal', 'open-choose-pay-abonnement');
    }
  }, [isOpenChoosePayModal]);

  return (
    <ChoosePayModal
      discountPrice={price}
      isOpen={isOpenChoosePayModal}
      buyHandler={() => dispatch(buyAbonnement({ abonnementType, bookId }))}
      closeModal={() => {
        dispatch(buyAbonnementActions.setIsOpenChoosePayModal(false));
      }}
      back={() => {
        dispatch(buyAbonnementActions.setIsOpenChoosePayModal(false));
        if (onBack) onBack();
      }}
      isShowSaveCardConfirm={false}
      showMethods={[
        Methods.bankCard,
        Methods.SBP,
        Methods.savedBankCard,
      ]}
    />
  );
};
